var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseButton',{attrs:{"loading":_vm.isSaving,"variant":"primary"},on:{"click":_vm.onClick}},[_vm._v("\n  "+_vm._s(_vm.canSave ? 'Save' : 'Save & Next')+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }